import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue";
import _imports_0 from '../../../assets/audioGuide/r_ticket.png';
import _imports_1 from '../../../assets/audioGuide/ticket.png';
import _imports_2 from '../../../assets/audioGuide/r_picture.png';
import _imports_3 from '../../../assets/audioGuide/picture.png';
import _imports_4 from '../../../assets/audioGuide/r_location.png';
import _imports_5 from '../../../assets/audioGuide/location.png';
const _hoisted_1 = {
  key: 0,
  class: "recordTitle"
};
const _hoisted_2 = {
  key: 1,
  class: "exhibition-img"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "exhibition-box exhibition-container"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "flex-wrap": "wrap",
    "border-bottom": "solid 1px #d6d6d6",
    "position": "relative",
    "padding-bottom": "0.2rem"
  }
};
const _hoisted_7 = {
  key: 0,
  style: {
    "display": "flex",
    "align-items": "center"
  },
  class: "type"
};
const _hoisted_8 = {
  key: 0,
  class: "image-icon",
  src: _imports_0
};
const _hoisted_9 = {
  key: 1,
  class: "image-icon",
  src: _imports_1
};
const _hoisted_10 = {
  class: "exhibition-type"
};
const _hoisted_11 = {
  style: {
    "display": "flex",
    "align-items": "center"
  },
  class: "type"
};
const _hoisted_12 = {
  key: 0,
  class: "image-icon",
  src: _imports_2
};
const _hoisted_13 = {
  key: 1,
  class: "image-icon",
  src: _imports_3
};
const _hoisted_14 = {
  class: "exhibition-type"
};
const _hoisted_15 = {
  key: 1,
  style: {
    "display": "flex",
    "align-items": "center"
  },
  class: "type"
};
const _hoisted_16 = {
  key: 0,
  class: "image-icon",
  src: _imports_4
};
const _hoisted_17 = {
  key: 1,
  class: "image-icon",
  src: _imports_5
};
const _hoisted_18 = {
  class: "exhibition-address"
};
const _hoisted_19 = {
  style: {
    "margin-top": "0.2rem"
  }
};
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_audioItem = _resolveComponent("audioItem");
  const _component_guideBottom = _resolveComponent("guideBottom");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`audios ${_ctx.$route.query.fid == 152288 ? 'nxbwgAudios' : ''}`)
  }, [_ctx.$route.query.isPersonalCenter ? (_openBlock(), _createElementBlock("div", _hoisted_1, "浏览记录")) : _createCommentVNode("", true), !_ctx.$route.query.searchKey && !_ctx.$route.query.isPersonalCenter ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
    src: $data.detail.images
  }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [!_ctx.$route.query.searchKey && !_ctx.$route.query.isPersonalCenter ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_5, _toDisplayString($data.language ? $data.detail.en_name : $data.detail.exhibName), 1), _createElementVNode("div", _hoisted_6, [$data.detail.price ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_ctx.$route.query.fid == 152288 ? (_openBlock(), _createElementBlock("img", _hoisted_8)) : (_openBlock(), _createElementBlock("img", _hoisted_9)), _createElementVNode("div", _hoisted_10, _toDisplayString($data.detail.price), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_ctx.$route.query.fid == 152288 ? (_openBlock(), _createElementBlock("img", _hoisted_12)) : (_openBlock(), _createElementBlock("img", _hoisted_13)), _createElementVNode("div", _hoisted_14, _toDisplayString(!$data.language ? $data.detail.exhibType : $options.getType($data.detail.exhibType)), 1)]), $data.detail.exhibitionLocation ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_ctx.$route.query.fid == 152288 ? (_openBlock(), _createElementBlock("img", _hoisted_16)) : (_openBlock(), _createElementBlock("img", _hoisted_17)), _createElementVNode("div", _hoisted_18, _toDisplayString($data.language ? $data.detail.en_location : $data.detail.exhibitionLocation), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
    class: _normalizeClass(`exhibition-content ${$data.isFolded ? 'hide' : ''}`),
    innerHTML: $data.language ? $data.detail.en_desc : $data.detail.description
  }, null, 10, _hoisted_20), _createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleFold && $options.toggleFold(...args)),
    class: _normalizeClass(`state ${$data.isFolded ? 'nofold' : 'fold'}`)
  }, [_createElementVNode("span", null, _toDisplayString($data.isFolded ? `${this.language ? 'all' : '全部介绍'}` : `${this.language ? 'up' : '收起'}`), 1), _createElementVNode("img", {
    class: "richarrow",
    src: `${$data.isFolded ? require('../../../assets/audioGuide/arrow-down.png') : require('../../../assets/audioGuide/arrow-up.png')}`
  }, null, 8, _hoisted_21)], 2)])], 64)) : _createCommentVNode("", true), _createVNode(_component_audioItem, {
    audioList: !_ctx.$route.query.isPersonalCenter ? $data.audioList : $data.recordList,
    formData: $data.formData,
    language: $data.language
  }, null, 8, ["audioList", "formData", "language"]), _ctx.$route.query.fid == 152288 ? (_openBlock(), _createBlock(_component_guideBottom, {
    key: 1,
    activeIndex: _ctx.$route.query.isPersonalCenter ? 2 : ''
  }, null, 8, ["activeIndex"])) : _createCommentVNode("", true)])], 2);
}